<template>
  <div class="home">

  </div>
</template>

<script>
export default {
  name: 'Home',
  props: ['activeUser']
}
</script>
